import { createFileRoute } from "@tanstack/react-router";

import { PageTitle } from "@/components/PageTitle";

export const Route = createFileRoute(
  "/$organizationKey/$dossierId/outcome/$questionnaireId/charts",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <PageTitle title="outcomeCharts" />
      <div>Hello "/$organizationKey/$dossierId/outcome/$questionnaireId/charts"!</div>
    </>
  );
}
